import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAbstractPresenter, IconName, ILanguageObject } from '@core/interfaces';
import { IQuantityStepperComponent, IQuantityStepperPresenter } from './interfaces';
import { FormBuilder, FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class QuantityStepperPresenter
	extends IAbstractPresenter<IQuantityStepperComponent>
	implements IQuantityStepperPresenter
{
	loading$: Observable<boolean> = of(false);
	translations: ILanguageObject = {};
	formGroup: FormGroup;

	iconIncrement: IconName = 'plus';
	iconDecrement: IconName = 'minus';
	disabled: boolean = false;
	min: number = 1;
	max: number | null = null;

	changeStepper: EventEmitter<number> = new EventEmitter<number>();

	constructor(private formBuilder: FormBuilder) {
		super();

		this.formGroup = this.formBuilder.group({
			quantity: [1],
		});
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	_value: number = 1;
	onChange: (v: number) => void = () => {};
	onTouched: () => void = () => {};

	writeValue(value: number): void {
		this.view._value = value;
		this.formGroup.get('quantity')?.setValue(value);
	}

	registerOnChange(fn: (v: number) => void): void {
		this.view.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.view.onTouched = fn;
	}

	get value(): number {
		return this.view._value;
	}

	set value(v: number) {
		this.view._value = v;

		this.view.onChange(v);
	}

	increaseAmount(): void {
		const quantity = Number(this.formGroup.get('quantity')?.value ?? 1) + 1;

		if (this.view.max != null && this.view.max != undefined && quantity > this.view.max) return;

		this.view._value = quantity;
		this.formGroup.get('quantity')?.setValue(quantity);
	}

	decreaseAmount(): void {
		const quantity = Number(this.formGroup.get('quantity')?.value ?? 1) - 1;

		if (quantity < this.view.min) return;

		this.view._value = quantity;
		this.formGroup.get('quantity')?.setValue(quantity);
	}

	changeAmount(): void {
		this.view.changeStepper.emit(Number(this.formGroup.get('quantity')?.value ?? 1));
	}
}
